import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import SEO from '../../components/SEO';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import AppImage from '../../components/AppImage';
import { Users, Luggage } from 'lucide-react';

const YatraBooking = () => {
  const { cityName, destination } = useParams();
  const navigate = useNavigate();
  const [selectedDuration, setSelectedDuration] = useState('3n-4d');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [cityName, destination]);

  const formattedCityName = cityName?.charAt(0)?.toUpperCase() + cityName?.slice(1)?.toLowerCase();
  const formattedDestination = destination?.split('-')?.map((word) => word?.charAt(0)?.toUpperCase() + word?.slice(1))?.join(' ');

  const durations = [
  { id: '3n-4d', label: '3N 4D' },
  { id: '4n-5d', label: '4N 5D' },
  { id: '5n-6d', label: '5N 6D' },
  { id: '6n-7d', label: '6N 7D' },
  { id: '7n-8d', label: '7N 8D' },
  { id: '8n-9d', label: '8N 9D' },
  { id: '9n-10d', label: '9N 10D' }];

  // Route-specific pricing
  const isNandedRoute = cityName?.toLowerCase() === 'chandigarh' && destination?.toLowerCase()?.includes('nanded');

  const vehicles = isNandedRoute ? [
  { type: 'Maruti Dzire', luggage: 3, seats: 4, price: 38000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png", alt: 'White Maruti Dzire sedan car with sleek design parked on city street' },
  { type: 'Toyota Etios', luggage: 3, seats: 4, price: 41800, image: "https://img.rocket.new/generatedImages/rocket_gen_img_180dd98ea-1768379490874.png", alt: 'Toyota Etios sedan car for comfortable travel' },
  { type: 'Brezza', luggage: 4, seats: 4, price: 45600, image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b493177-1768380107788.png", alt: 'Maruti Brezza compact SUV in urban setting with modern design' },
  { type: 'Maruti Ertiga', luggage: 4, seats: 6, price: 49400, image: 'https://img.rocket.new/generatedImages/rocket_gen_img_10a91d818-1764720425845.png', alt: 'Maruti Ertiga MPV with spacious seating capacity parked outdoors' },
  { type: 'Innova Crysta', luggage: 6, seats: 6, price: 61600, image: "https://images.unsplash.com/photo-1651742425034-8bf38f70f746", alt: 'Toyota Innova Crysta luxury MPV in silver color with premium features' },
  { type: 'Innova Hycross', luggage: 5, seats: 6, price: 79800, image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png", alt: 'Toyota Innova Hycross latest model with hybrid technology and premium comfort' },
  { type: 'Tempo Traveller', luggage: 8, seats: 12, price: 106400, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b6efb5fd-1765716730341.png", alt: 'White tempo traveller 12 seater minibus for group travel' },
  { type: 'Tempo Traveller', luggage: 15, seats: 17, price: 114000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_16f41fd6f-1768440186961.png", alt: 'White tempo traveller 17 seater for large group travel' },
  { type: 'Fortuner', luggage: 5, seats: 6, price: 133000, image: 'https://img.rocket.new/generatedImages/rocket_gen_img_144c4e8d9-1766473631173.png', alt: 'Toyota Fortuner luxury SUV with powerful performance and premium interiors' },
  { type: 'Urbania', luggage: 9, seats: 12, price: 136800, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e968eef3-1767645976455.png", alt: 'Force Urbania luxury van for group travel with premium interiors' },
  { type: 'Force Urbania', luggage: 16, seats: 16, price: 144400, image: 'https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png', alt: 'Force Urbania 16 seater luxury van with premium interiors' },
  { type: 'Tempo Traveller', luggage: 15, seats: 25, price: 144400, image: "https://img.rocket.new/generatedImages/rocket_gen_img_16f41fd6f-1768440186961.png", alt: 'Extra large tempo traveller 25 seater for large group travel' }] : [
  { type: 'Maruti Dzire', luggage: 3, seats: 4, price: 22000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png", alt: 'White Maruti Dzire sedan car with sleek design parked on city street' },
  { type: 'Maruti Ertiga', luggage: 4, seats: 6, price: 28600, image: 'https://img.rocket.new/generatedImages/rocket_gen_img_10a91d818-1764720425845.png', alt: 'Maruti Ertiga MPV with spacious seating capacity parked outdoors' },
  { type: 'Kia Carens', luggage: 5, seats: 6, price: 33000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_10c28221a-1768075340455.png", alt: 'Kia Carens premium MPV for comfortable travel' },
  { type: 'Innova Crysta', luggage: 6, seats: 6, price: 37400, image: "https://img.rocket.new/generatedImages/rocket_gen_img_144c4e8d9-1766473631173.png", alt: 'Toyota Innova Crysta luxury MPV in silver color with premium features' },
  { type: 'Innova Crysta 7+1', luggage: 6, seats: 7, price: 39600, image: "https://img.rocket.new/generatedImages/rocket_gen_img_17142d727-1768366661943.png", alt: 'Toyota Innova Crysta 7+1 seater for large families' },
  { type: 'Innova Hycross', luggage: 5, seats: 6, price: 46200, image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png", alt: 'Toyota Innova Hycross latest model with hybrid technology and premium comfort' },
  { type: 'Tempo Traveller', luggage: 8, seats: 12, price: 61600, image: "https://img.rocket.new/generatedImages/rocket_gen_img_114e4d671-1768440186864.png", alt: 'White tempo traveller 12 seater minibus for group travel' },
  { type: 'Tempo Traveller', luggage: 15, seats: 17, price: 66000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_114e4d671-1768440186864.png", alt: 'White tempo traveller 17 seater for large group travel' },
  { type: 'Urbania', luggage: 9, seats: 12, price: 79200, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e968eef3-1767645976455.png", alt: 'Force Urbania luxury van for group travel with premium interiors' },
  { type: 'Force Urbania', luggage: 16, seats: 16, price: 83600, image: 'https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png', alt: 'Force Urbania 16 seater luxury van with premium interiors' },
  { type: 'Tempo Traveller', luggage: 15, seats: 25, price: 83600, image: 'https://img.rocket.new/generatedImages/rocket_gen_img_1b6efb5fd-1765716730341.png', alt: 'Extra large tempo traveller 25 seater for large group travel' }];


  const handleSelectCar = (vehicle) => {
    navigate('/car-details', {
      state: {
        vehicle: {
          ...vehicle,
          name: vehicle?.type,
          image: vehicle?.image,
          price: vehicle?.price
        },
        route: {
          from: cityName,
          to: destination
        }
      }
    });
  };

  return (
    <>
      <SEO
        title={`${formattedCityName} to ${formattedDestination} Yatra - Book Cabs | Advait Tour and Travels`}
        description={`Book cabs for ${formattedCityName} to ${formattedDestination} yatra. Choose from various vehicles and duration packages. Comfortable pilgrimage travel.`}
        keywords={`${cityName} to ${destination} yatra, ${destination} yatra booking, ${cityName} pilgrimage travel`}
        canonicalUrl={`${window.location?.origin}/yatra-booking/${cityName}/${destination}`}
        ogTitle={`${formattedCityName} to ${formattedDestination} Yatra - Book Cabs | Advait Tour and Travels`}
        ogDescription={`Book cabs for ${formattedCityName} to ${formattedDestination} yatra. Choose from various vehicles and duration packages. Comfortable pilgrimage travel.`}
        ogUrl={`${window.location?.origin}/yatra-booking/${cityName}/${destination}`}
        structuredData={{
          "@context": "https://schema.org",
          "@type": "TravelAgency",
          "name": "Advait Tour and Travels",
          "description": `${formattedCityName} to ${formattedDestination} yatra booking`
        }} />

      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="py-20">
          {/* Hero Section */}
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 py-16 mb-12">
            <div className="container mx-auto px-4">
              <h1 className="text-4xl md:text-5xl font-bold text-white text-center mb-6">
                {formattedCityName} to {formattedDestination} Yatra
              </h1>
              
              {/* Duration Tabs */}
              <div className="flex flex-wrap justify-center gap-4">
                {durations?.map((duration) =>
                <button
                  key={duration?.id}
                  onClick={() => setSelectedDuration(duration?.id)}
                  className={`px-6 py-3 rounded-lg font-bold transition-all duration-300 ${
                  selectedDuration === duration?.id ?
                  'bg-yellow-400 text-gray-900' : 'bg-white/20 text-white hover:bg-white/30'}`
                  }>

                    {duration?.label}
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* Vehicle Cards */}
          <div className="container mx-auto px-4 mb-16">
            <div className="grid grid-cols-1 gap-6 max-w-6xl mx-auto">
              {vehicles?.map((vehicle, index) =>
              <div
                key={index}
                className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-200">

                  <div className="flex flex-col md:flex-row items-center gap-6 p-6">
                    {/* Vehicle Image */}
                    <div className="w-full md:w-64 h-48 flex-shrink-0">
                      <AppImage
                      src={vehicle?.image}
                      alt={vehicle?.alt}
                      className="w-full h-full object-contain" />

                    </div>

                    {/* Vehicle Details */}
                    <div className="flex-1 flex flex-col md:flex-row items-center justify-between gap-6 w-full">
                      {/* Car Type and Name */}
                      <div className="text-center md:text-left">
                        <p className="text-sm text-gray-500 font-medium uppercase mb-1">CAR TYPE</p>
                        <h3 className="text-2xl font-bold text-gray-900 mb-2">{vehicle?.type}</h3>
                      </div>

                      {/* Specifications */}
                      <div className="flex items-center gap-8">
                        <div className="flex items-center gap-3">
                          <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-lg">
                            <Luggage className="text-blue-600" size={24} />
                          </div>
                          <div>
                            <p className="text-lg font-bold text-gray-900">{vehicle?.luggage} Luggage</p>
                          </div>
                        </div>
                        <div className="flex items-center gap-3">
                          <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-lg">
                            <Users className="text-blue-600" size={24} />
                          </div>
                          <div>
                            <p className="text-lg font-bold text-gray-900">{vehicle?.seats} Seats</p>
                          </div>
                        </div>
                      </div>

                      {/* Price and Button */}
                      <div className="flex flex-col items-center gap-3">
                        <div className="text-right">
                          <p className="text-3xl font-bold text-green-600">₹{vehicle?.price?.toLocaleString('en-IN')}/-</p>
                          <p className="text-sm text-gray-500">Inc. of Taxes*</p>
                        </div>
                        <button
                        onClick={() => handleSelectCar(vehicle)}
                        className="px-8 py-3 bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-bold rounded-lg transition-all duration-200 whitespace-nowrap">

                          Select Car
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Contact Card Section */}
          <div className="container mx-auto px-4 mb-16">
            <div className="max-w-4xl mx-auto bg-gradient-to-r from-blue-500 to-blue-600 rounded-2xl shadow-xl p-8 text-center">
              <h2 className="text-3xl font-bold text-white mb-6">
                We're here for you 24/7!
              </h2>
              <p className="text-xl text-white mb-6">
                Give us a call anytime
              </p>
              <a
                href="tel:+917998666660"
                className="inline-flex items-center gap-3 px-8 py-4 bg-white text-blue-600 font-bold text-2xl rounded-full hover:bg-gray-100 transition-colors duration-300 shadow-lg hover:shadow-xl">

                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                +91-79986-66660
              </a>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </>);

};

export default YatraBooking;